<template>
    <div id="unmute-play-overlay" v-bind:class="bar_control_overlay" v-if="!isFetching">
        <button class="btn btn-secondary rounded-pill text-uppercase" @click="handleUnmuteClick">
            {{ textButton }}
        </button>
    </div>
</template>

<script setup>
import { ref, watch } from 'vue';
import { useTranslation } from "@/composables/useTranslation";
import { usePlayerStore } from '@/playerVue3/storage/storePlayer';

// INITIALIZE STORE & COMPOSABLES
const store = usePlayerStore();
const { translate } = useTranslation();

// PROPS & EMITS

// REACTIVE VARIABLES
const bar_control_overlay = ref('control-unmute-autoplay text-center');
const isFetching = ref(false);
const textButton = ref(translate('label.tap_to_unmute'));

// COMPUTED PROPERTIES

// METHODS
const handleUnmuteClick = () => {
    const player = store.getPlayer;
    if (player) {
        store.setIsVideoMuted(true);
        isFetching.value = true;
    }
};

// LIFECYCLE HOOKS
watch(() => store.getIsVideoMuted, (newVal) => {
    if (newVal == false && store.getIsAutoPlay) {
        isFetching.value = true;
    }
});
</script>
